<img src='../../../../assets/images/default-user-dp.svg' [lazyLoad]="displayPicture?.url" class="img-circle user-display-image">
